import { EstimatedSumInsured } from 'scenes/common/api/quote/estimatedSumInsured/types';

export enum CoverType {
  Unspecified = '',
  Building = 'Building',
  BuildingAndContents = 'Building & Contents',
  Contents = 'Contents',
}

export enum BuildingType {
  Unspecified = '',
  FreestandingHouse = 'CncrtSlab',
  Terrace = 'SemiDetchd',
  Townhouse = 'TownHouse',
  Unit = 'Flat',
  Other = 'TrnsPrtbl',
}

export enum BuildingLevel {
  Unspecified = '',
  Basement = 'Basement',
  GrdFloor = 'GrdFloor',
  Level1 = 'Level1',
  Level2 = 'Level2',
  Level3Plus = 'Level3Plus',
}

export const BUILDING_LEVEL_OPTIONS = [
  { label: 'Basement', value: BuildingLevel.Basement },
  { label: 'Ground', value: BuildingLevel.GrdFloor },
  { label: '1st floor', value: BuildingLevel.Level1 },
  { label: '2nd floor', value: BuildingLevel.Level2 },
  { label: '3rd floor or higher', value: BuildingLevel.Level3Plus },
];

export const BEDROOM_NUMBER_OPTIONS = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8 or more', value: 8 },
];

export enum SumInsuredType {
  Unspecified = '',
  Estimated = 'Estimated sum insured',
  Agreed = 'Enter different sum insured',
  Entered = 'Enter sum insured',
}

export const SUM_INSURED_VALUES: Partial<Record<
  BuildingType | string,
  EstimatedSumInsured
>> = {
  [BuildingType.Other]: {
    estimatedValue: 125000,
    maxLimit: 250000,
    minLimit: 125000,
  },
  default: {
    estimatedValue: 125000,
    maxLimit: 1000000,
    minLimit: 125000,
  },
  notAvailable: {
    estimatedValue: 0,
    maxLimit: 1000000,
    minLimit: 125000,
  },
};
